import {useQuery} from '@tanstack/react-query';
import {fetchFeatureFlags, getLocalStorageFeatureFlags} from 'infra/http/utils/fetch-feature-flag';
import {FEATURE_FLAG_CACHE_TIME} from 'infra/http/utils/fetch-feature-flag/constants';

import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';

function useFeatureFlagsQuery() {
	return useQuery({
		queryKey: [QUERY_KEYS.FEATURE_FLAGS, {excludeWalletCode: true}],
		queryFn: fetchFeatureFlags,
		refetchInterval: FEATURE_FLAG_CACHE_TIME,
		initialData: getLocalStorageFeatureFlags()?.data,
		retry: 2,
		retryOnMount: false,
	});
}

export {useFeatureFlagsQuery};
